(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityFieldAddCtrl', EntityFieldAddCtrl);

    EntityFieldAddCtrl.$inject = ['$scope', 'entityField', 'existingNames', 'FieldTypesService', 'EntityTemplatesService', 'DialogService', 'DialogInstance'];

    function EntityFieldAddCtrl($scope, entityField, existingNames, FieldTypesService, EntityTemplatesService, DialogService, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.entityField = newEntityField();
        vm.fieldTypeChange = fieldTypeChange;
        vm.fieldType = { Attributes: [] };
        vm.fieldTypes = [];
        vm.enumerations = [];
        vm.pageHeading = 'Add Field';
        vm.addEnumeration = addEnumeration;
        vm.deleteEnumeration = deleteEnumeration;
        vm.enumerationTypes = ['Single', 'Multiple'];
        vm.relationshipTypes = [{ Label: 'Single', Value: 'One' }, { Label: 'Multiple', Value: 'Many' }];
        vm.currentTypes = ['Dollar ($)', 'Pound (£)', 'Euro (€)'];
        vm.widths = [{ Label: 'Full', Value: 100 }, { Label: 'Three Quarters', Value: 75 }, { Label: 'Two Thirds', Value: 66 }, { Label: 'Half', Value: 50 }, { Label: 'Third', Value: 33 }, { Label: 'Quarter', Value: 25 }];
        vm.updateCurrencyPreview = updateCurrencyPreview;
        Object.defineProperty(vm, 'fieldInputSettingsForDefault', { get: getFieldInputSettingsForDefault });
        Object.defineProperty(vm, 'entityFieldType', { get: getEntityFieldType });

        activate();

        function activate() {
            if (entityField != 'new') {
                vm.pageHeading = 'Field';
                // The value is copied, we do not want to directly bind otherwise the source value will be changed even if the dialog is cancelled
                vm.entityField = angular.copy(entityField);

                // Setup the enumerations if they exist
                if (!angular.isUndefined(vm.entityField.Enumerations) && vm.entityField.Enumerations !== null && vm.entityField.Enumerations !== '') {
                    var enumerationParts = vm.entityField.Enumerations.split(',');

                    angular.forEach(enumerationParts, function (enumerationPart) {
                        vm.enumerations.push(enumerationPart);
                    });
                }
            }
            
            loadFieldTypes();
            loadEntityTemplates();

            $scope.$watch('vm.entityField.Name', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    vm.addEntityFieldForm.name.$setValidity('unique', !_.some(existingNames, function (existingName) { return vm.entityField.Name === existingName; }));
                }
            });
        }

        function loadEntityTemplates() {
            EntityTemplatesService.query()
                .then(getEntityTemplatesOk)
                .catch(getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                vm.entityTemplateList = data.EntityTemplates;
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Template', response);
            }
        }

        function loadFieldTypes() {
            FieldTypesService.getFieldTypes(true)
                .then(getFieldTypesOk)
                .catch(getFieldTypesError);

            function getFieldTypesOk(data) {
                vm.fieldTypes = _.filter(data, function (fieldType) { return fieldType.Active || (!_.isNil(vm.entityField) && !_.isNil(vm.entityField.FieldType) && vm.entityField.FieldType === fieldType.Name); });

                updateCurrentFieldType();
                updateAvailableAttributes();
            }

            function getFieldTypesError(response) {
                DialogService.error('Error fetching file types', response);
            }
        }

        function ok() {
            // If enumerations exist, they should be updated to the attribute value
            if (!angular.isUndefined(vm.enumerations) && vm.enumerations !== null && vm.enumerations.length > 0) {
                vm.entityField.Enumerations = '';
                var firstValue = true;
                angular.forEach(vm.enumerations, function (enumeration) {
                    if (firstValue) {
                        vm.entityField.Enumerations = enumeration;
                        firstValue = false;
                    }
                    else {
                        vm.entityField.Enumerations = vm.entityField.Enumerations + ',' + enumeration;
                    }
                });
            }

            DialogInstance.ok(vm.entityField);
        }

        function cancel() {
            DialogInstance.cancel();
        }

        function updateCurrentFieldType() {
            var fieldType = {};

            if (vm.entityField.FieldType === 'Relationship') {
                fieldType = _.find(vm.fieldTypes, function (n) { return !_.isNil(n.RelationshipField) && n.RelationshipField.EntityTemplateId == vm.entityField.EntityTemplateId; });
            } else {
                fieldType = _.find(vm.fieldTypes, function (n) { return n.Name == vm.entityField.FieldType; });
            }

            vm.currentFieldType = fieldType;
        }

        function updateAvailableAttributes()
        {
            if (!_.isNil(vm.currentFieldType))
            {
                vm.currentDataType = vm.currentFieldType.DataType;
            } else {
                vm.currentDataType = null;
                vm.fieldType = null;
            }

            if (!_.isNil(vm.currentFieldType) && !_.isNil(vm.currentFieldType.Name)) {
                // Do any initialisation that is specific to a type of field
                switch (vm.currentFieldType.Name) {
                    case 'Currency':
                        vm.updateCurrencyPreview();
                        break;
                }
            }
        }

        function fieldTypeChange() {
            // Remove the default value, since the field types do not always share the same data format
            if (!_.isNil(vm.entityField) && !_.isNil(vm.entityField.Default)) {
                delete vm.entityField.Default;
            }

            if (!_.isNil(vm.currentFieldType)) {
                vm.entityField.FieldType = vm.currentFieldType.Name;

                if (vm.currentFieldType.Name === 'Relationship' && !_.isNil(vm.currentFieldType.RelationshipField)) {
                    vm.entityField.EntityTemplateId = vm.currentFieldType.RelationshipField.EntityTemplateId;
                    vm.entityField.RelationshipType = vm.currentFieldType.RelationshipField.RelationshipType;
                    vm.entityField.Cardinality = 'One';
                }
            } else {
                vm.entityField = newEntityField();
            }

            updateAvailableAttributes();
        }

        function addEnumeration() {
            vm.enumerations.push('');
        }

        function deleteEnumeration(index) {
            vm.enumerations.splice(index, 1);
        }

        function updateCurrencyPreview() {
            var result = '1234567890';

            if (!angular.isUndefined(vm.entityField.Decimal) && vm.entityField.Decimal !== null && vm.entityField.Decimal !== 0) {
                var position = result.length - vm.entityField.Decimal;
                result = result.substr(0, position) + '.' + result.substr(position);
            }

            if (!angular.isUndefined(vm.entityField.Symbol)) {
                switch (vm.entityField.Symbol) {
                    case 'Dollar ($)':
                        result = '$' + result;
                        break;
                    case 'Pound (£)':
                        result = '£' + result;
                        break;
                    case 'Euro (€)':
                        result = '€' + result;
                        break;
                }
            }

            vm.currencyPreview = result;
        }

        /*
         * Get the field type which is currently referenced by entityField.FieldType.
         * There are small windows of time where this will not be the same as vm.currentFieldType.
         *
         * @returns {object} - Returns the field type currently referenced by entityField.FieldType
         */
        function getEntityFieldType() {
            var fieldType = _.find(vm.fieldTypes, function (n) { return !_.isNil(vm.entityField) && n.Name == vm.entityField.FieldType; });

            if (!_.isEqual(getEntityFieldType.fieldType, fieldType)) {
                getEntityFieldType.fieldType = fieldType;
            }

            return getEntityFieldType.fieldType;
        }

        /*
         * Get the field settings to be used for setting up the 'Default' value input
         *
         * @returns {object} - Returns a field setting which is compatible with the field input directives
         */
        function getFieldInputSettingsForDefault() {
            var fieldSettings = angular.copy(vm.entityField);
            fieldSettings.Name = 'Default';
            delete fieldSettings.Mandatory;

            if (!_.isNil(vm.entityFieldType) && vm.entityFieldType.Name === 'List') {
                fieldSettings.Enumerations = '';
                angular.forEach(vm.enumerations, function (enumeration) {
                    fieldSettings.Enumerations = fieldSettings.Enumerations + (fieldSettings.Enumerations === '' ? '' : ',') + enumeration;
                });
            }

            if (!angular.equals(getFieldInputSettingsForDefault.fieldSettings, fieldSettings)) {
                getFieldInputSettingsForDefault.fieldSettings = fieldSettings;
            }

            return getFieldInputSettingsForDefault.fieldSettings;
        }

        function newEntityField() {
            return {
                Name: '',
                Description: '',
                Mandatory: false,
                Visible: true,
                HelpText: '',
                FieldType: 'Text',
                Width: 100
            };
        }
    }
})();
